import { render, staticRenderFns } from "./HomeFrame.vue?vue&type=template&id=657d211e&scoped=true&"
import script from "./HomeFrame.vue?vue&type=script&lang=js&"
export * from "./HomeFrame.vue?vue&type=script&lang=js&"
import style0 from "./HomeFrame.vue?vue&type=style&index=0&id=657d211e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d211e",
  null
  
)

export default component.exports